import type { ReactNode } from "react";

import type { UUID } from "@/core/types";

import { useUpdateNoteAddendum } from "../../api/mutations/useUpdateNoteAddendum";

import { GeneralAddendumForm } from "./GeneralAddendumForm";

type EditGeneralAddendumProps = {
  addendumId: UUID;
  children?: ReactNode;
  credentials: string | undefined;
  defaultValue: string;
  noteId: UUID;
  onCancel: () => void;
  onSuccess: () => void;
  patientId: UUID;
  signature: string | undefined;
};

export function EditGeneralAddendum({
  addendumId,
  children,
  credentials,
  defaultValue,
  noteId,
  onCancel,
  onSuccess,
  patientId,
  signature,
}: EditGeneralAddendumProps) {
  const { isPending, mutate } = useUpdateNoteAddendum({ onSuccess });

  return (
    <GeneralAddendumForm
      defaultValue={defaultValue}
      isPending={isPending}
      mutate={(addendum) =>
        mutate({ addendum, addendumId, credentials, noteId, patientId, signature })
      }
      onCancel={onCancel}
    >
      {children}
    </GeneralAddendumForm>
  );
}
